import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

class ngHead extends ngElement
{
	#owner;
	
	constructor () {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {
		
		this.#owner = this.getRootNode().host;

		if (ninegrid.j.querySelectorAll(this.#owner).hasClass("simple")) return;
		
		this.shadowRoot.innerHTML = `
			<ng-menu></ng-menu>
			<ng-title></ng-title>
			<ng-custom></ng-custom>
		`;

		super.connectedCallback();
	};
}

class ngTitle extends HTMLElement
{
	#owner;
	
	constructor () {
		super();
	}
	
	connectedCallback() {
		if (!this.getRootNode().host) return;
		
		this.#owner = this.getRootNode().host.getRootNode().host;
		
		this.innerHTML = `<span>${this.#owner.getAttribute("caption")}</span>`;
		
		$("span", this).on("dblclick", e => {
			const link = '<font color="green">https://www.ninegrid.net</font>';
			e.currentTarget.innerHTML = e.currentTarget.innerHTML == link ? `<span>${this.#owner.getAttribute("caption")}</span>` : link;
		});
	};
}

class ngCustom extends HTMLElement
{
	#owner;
	
	constructor () {
		super();
	}
	
	connectedCallback() {
		if (!this.getRootNode().host) return;
		
		this.#owner = this.getRootNode().host.getRootNode().host;
		
		this.innerHTML = `<div></div>`;
	};
	
	add = (element) => {
		this.querySelector("div:first-child").append(element);
	};
}

if (!customElements.get('ng-title')) {
	customElements.define("ng-title", ngTitle);
}

if (!customElements.get('ng-custom')) {
	customElements.define("ng-custom", ngCustom);
}

if (!customElements.get('ng-head')) {
	customElements.define("ng-head", ngHead);
}
